<form [formGroup]="dynamicForm" (ngSubmit)="onSubmit()">
    <div class="card-body" *ngFor="let group of formGroupInfoDetails">
        <div class="col-sm-12 col-xl-12 d-flex">
            <div class="col-sm-12 col-xl-6 p-3" *ngFor="let formDetails of group.formRow">
                <div class="card shadow shadow-showcase">
                    <div class="card-header bg-secondary text-white r-p">
                        <h6>{{formDetails.formName}}</h6>
                    </div>
                    <div class="card-body">
                        <div class="form-group row" *ngFor="let field of formDetails.formFileds">
                            <label class="col-sm-3 col-form-label" [for]="field.name">{{ field.label }}</label>
                            <div class="col-md-9">
                                <input (blur)="changeFormCallback()" (wheel)="disableWheel($event)" class="form-control" [id]="field.name"
                                    [type]="field.type" [formControlName]="field.name" [readonly]="field?.readonly"
                                    [attr.placeholder]="field.placeholder">
                    
                                <!-- Display validation error messages -->
                                <div *ngIf="dynamicForm.get(field.name)?.invalid && dynamicForm.get(field.name)?.touched">
                                    <small *ngIf="dynamicForm.get(field.name)?.errors?.['required']">
                                        {{ field.label }} is required.
                                    </small>
                                    <small *ngIf="dynamicForm.get(field.name)?.errors?.['email']">{{ field.label }} must be a
                                        valid email.</small>
                                    <small *ngIf="dynamicForm.get(field.name)?.errors?.['min']">{{ field.label }} must be at
                                        least 18.</small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <button class="btn btn-primary float-end" type="submit">Generate</button>
</form>
